import React from 'react';
import { BaseComponent } from "project/general";
import { render } from "preact";
import { BaseForm, formConstants } from 'shared/base-form';
import { notificationTypes } from 'project/general';
import { notificationService } from 'project/services';
import { SearchResultCard } from './search-result-card.jsx';

class HeritageSearchComponent extends BaseComponent {

    static getRequiredRefs() {
        return ["secondarySearchForm", "secondarySearchResultsPlaceholder", "secondarySearchSubmit"];
    }

    static getNamespace() {
        return 'heritage-search';
    }

    onInit() {
        this.onInitForm();

        if (this.refs.primarySearchResultsPlaceholder) {
            const primarySearchResults = JSON.parse(this.refs.primarySearchResultsPlaceholder.dataset.primarySearchResults);
            if (primarySearchResults) {
                this.renderSearchResults(primarySearchResults, this.refs.primarySearchResultsPlaceholder);
            }
        }


        this.refs.secondarySearchSubmit.addEventListener("click", () => {
            this.formInstance.onSubmit();
        });
    }

    onInitForm() {
        this.formInstance = new BaseForm(this.refs.secondarySearchForm, {
            errorsSummary: document.getElementById("data-errors-summary"),
            submitElement: this.refs.secondarySearchSubmit,
            onSuccessfulSubmit: (response) => {
                const searchResults = response.data?.data;


                if (searchResults === undefined) {
                    const message = response.data?.errors?.[0] || "There was a problem";
                    notificationService.push({
                        message,
                        type: notificationTypes.WARNING,
                    });
                } else {
                    this.renderSearchResults(searchResults.results, this.refs.secondarySearchResultsPlaceholder);
                }
            },
            onFailedSubmit: () => {
                notificationService.push({
                    message: "There was an error",
                    type: notificationTypes.ERROR,
                });
            },
            enctype: formConstants.ENCTYPE_JSON
        });
    }

    renderSearchResults(searchResults, placeholder) {
        searchResults.length > 0 ? render(
            searchResults?.map(searchResult => (
                <SearchResultCard searchResult={searchResult} />
            )),
            placeholder
        ) : render(<p>No results for search</p>, placeholder)


    }
}

export default HeritageSearchComponent;
